import { h, VNode } from "preact";

export function Chip(props: {
    clickable?: boolean,
    onClick?: () => void,
    type: "info" | "warning" | "error" | "success" | "primary" | "secondary",
    class?: string,
    icon?: string,
    tooltip?: string,
    tooltipType?: "info" | "warning" | "error" | "success" | "primary" | "secondary" | "accent" | "highlight",
    tooltipPosition?: "top" | "left" | "right" | "bottom",
    tooltipAlignment?: "start" | "center" | "end",
    children: string | VNode | (string | VNode)[]
}) {
    const cls = "chip"
        + (props.clickable ? " clickable" : "")
        + " " + props.type
        + (props.tooltip ? " tooltip" : "")
        + (props.tooltipType ? " tooltip-" + props.tooltipType : "")
        + (props.tooltipPosition && props.tooltipPosition !== "bottom" ? " tooltip-" + props.tooltipPosition : "")
        + (props.tooltipAlignment && props.tooltipAlignment !== "center" ? " tooltip-" + props.tooltipAlignment : "")
        + (props.class ? " " + props.class : "");

    return <span class={cls} onClick={props.onClick} data-icon={props.icon} data-tooltip={props.tooltip}>
        <span>{props.children}</span>
    </span>;
}